export default __webpack_public_path__ + "static/media/BUSD.4ccb185f.svg";